import Vuex from 'vuex'
import Vue from 'vue'
import state from './state.js'
import getters from './getters.js'
import actions from './actions.js'
import mutations from './mutations.js'

Vue.use(Vuex);

const store = new Vuex.Store({ state, getters, mutations, actions });
const { session_id, user_id, user_level } = localStorage;

store.commit('LOGIN', { session_id, user_id, user_level } || {});

// 하우스 애드: 앱관리/보상타입/광고관리 진입 시 HOUSEAD_FETCH_CMS_INIT 로 API에서 로드

export default store;